import { useFetch } from "../useFetch";

export const usePublicFaq = () => {
  const [data, isLoading, isError] = useFetch(
    '/research/japi/public/content/faq',
    null,
    'GET'
  );

  const publicFaqItems = data?.data || [];

  return [publicFaqItems, isLoading, isError];
};